import {Component, OnDestroy, OnInit} from '@angular/core';
import {RubixDocumentsService} from "../../rubix-documents.service";
import {Subscription} from "rxjs";
import {FileSystemFolderAndDocument} from "../../../../../../../swaggerServices";

@Component({
    selector: 'app-grid-view',
    templateUrl: './grid-view.component.html',
    styleUrls: ['./grid-view.component.scss'],
    standalone: false
})
export class GridViewComponent implements OnInit, OnDestroy {

  children: FileSystemFolderAndDocument[] = [];
  loading: boolean;

  subscriptions: Subscription[] = [];

  constructor(
    public rubixDocumentsService: RubixDocumentsService
  ) { }

  ngOnInit(): void {
    this.children = this.rubixDocumentsService.currentFolderDetails.folderChildren;
    this.loading = this.rubixDocumentsService.loading;

    this.subscriptions.push(
      this.rubixDocumentsService.notifyNavigationChange$.subscribe(value => {
        this.loading = this.rubixDocumentsService.loading;
        this.children = this.rubixDocumentsService.currentFolderDetails.folderChildren;
      })
    );

    this.subscriptions.push(
      this.rubixDocumentsService.notifyFolderViewChange$.subscribe(value => {
        this.children = this.rubixDocumentsService.currentFolderDetails.folderChildren;
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  isChildSelected(child: FileSystemFolderAndDocument): boolean {
    return this.rubixDocumentsService.isChildSelected(child);
  }

  onCheckboxClick(child: FileSystemFolderAndDocument) {
    this.rubixDocumentsService.toggleSelectChild(child);
  }

  toFolder(folder: FileSystemFolderAndDocument) {
    if (folder.wstype === 'folder') {
      this.rubixDocumentsService.toFolder(folder.id, folder.name);
    }
  }

  getTitle(child: FileSystemFolderAndDocument) {
    if(child.wstype === 'folder') {
      return child.name
    }
    return `${child.name}.${child.extension}`;
  }
}
